import { UserInfo } from "../../api/dtos/user/UserProfile";

export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_DEFINE_PASSWORD = 'AUTH_DEFINE_PASSWORD';

export interface AuthLoginAction {
    type: typeof AUTH_LOGIN;
    user: UserInfo;
    accessToken: string;
    refreshToken: string;
    expirationDate: number;
    tokenType: string;
}

export interface AuthLogoutAction {
    type: typeof AUTH_LOGOUT;
}

export interface AuthDefinePasswordAction {
    type: typeof AUTH_DEFINE_PASSWORD;
}

export type AuthActionTypes =
    | AuthLoginAction
    | AuthLogoutAction
    | AuthDefinePasswordAction;